<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
let xLabel = ['2019', '2020', '2021', '2022', '2023', '2023'];
let L0 = ['40', '60', '22', '85', '50', '40'];
let L1 = ['50', '30', '72', '35', '80', '60'];
let L3 = ['20', '10', '22', '5', '50', '20'];

// 创建ECharts配置对象
const option = {
  // backgroundColor: '#0b112a',
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    align: 'left',
    right: '90px',
    type: 'plain',
    top:'15px',
    textStyle: {
      color: '#fff',
      fontSize: 12,
    },
    itemGap: 25,
    itemWidth: 25,
    itemHeight: 25,
    // icon:'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
    data: [
      { name: '强筋',icon: 'image://https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/q.png'},
      { name: '中筋',icon: 'image://https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/z.png'},
      { name: '弱筋',icon: 'image://https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/r.png'},

    ]
  },
  grid: {
    top: '70px',
    left: '80px',
    right: '40px',
    bottom: '15%',
    // containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      axisLine: {
        //坐标轴轴线相关设置。数学上的x轴
        show: false,
        lineStyle: {
          color: '#233653',
        },
      },
      axisLabel: {
        //坐标轴刻度标签的相关设置
        textStyle: {
          color: '#fff',
          padding: 10,
          fontSize: 14,
        },
        formatter: function (data) {
          return data;
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#192a44',
        },
      },
      axisTick: {
        show: false,
      },
      data: xLabel,
    },
  ],
  yAxis: [
    {
      name: '',
      nameTextStyle: {
        color: '#7ec7ff',
        fontSize: 14,
        padding: 10,
      },
      min: 0,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#306269',
        },
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: '#fff',
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#fff',
          padding: 10,
        },
        formatter: function (value) {
          if (value === 0) {
            return value;
          }
          return value+'%';
        },
      },
      axisTick: {
        show: false,
      },
    },
  ],
  series: [
    {
      name: '强筋',
      type: 'line',
      symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
      showAllSymbol: true,
      symbolSize: 0,
      smooth: true,
      lineStyle: {
        normal: {
          width: 2,
          color: 'rgba(84,131,255,1)', // 线条颜色
        },
        borderColor: 'rgba(0,0,0,.4)',
      },
      itemStyle: {
        color: 'rgba(84,131,255,1)',
      },
      tooltip: {
        show: true,
      },
      areaStyle: {
        //区域填充样式
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: 'rgba(84,131,255,.3)',
              },
              {
                offset: 1,
                color: 'rgba(84,131,255, 0)',
              },
            ],
            false
          ),
          shadowColor: 'rgba(25,163,223, 0.5)', //阴影颜色
          shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
        },
      },
      data: L0,
    },
    {
      name: '中筋',
      type: 'line',
      symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
      showAllSymbol: true,
      symbolSize: 0,
      smooth: true,
      lineStyle: {
        normal: {
          width: 2,
          color: 'rgba(248,172,6,1)',
          // color: 'rgba(77,192,36,1)', // 线条颜色
        },
      },
      itemStyle: {
        color: 'rgba(248,172,6,1)',
        // color: 'rgba(77,192,36,1)',
      },
      tooltip: {
        show: true,
      },
      areaStyle: {
        //区域填充样式
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: 'rgba(248,172,6,.3)',
                // color: 'rgba(77,192,36,.3)',
              },
              {
                offset: 1,
                // color: 'rgba(77,192,36, 0)',
                color: 'rgba(248,172,6, 0)',
              },
            ],
            false
          ),
          shadowColor: 'rgba(10,219,250, 0.5)', //阴影颜色
          shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
        },
      },
      data: L1,
    },
    {
      name: '弱筋',
      type: 'line',
      symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
      showAllSymbol: true,
      symbolSize: 0,
      smooth: true,
      lineStyle: {
        normal: {
          width: 2,
          // color: 'rgba(248,172,6,1)', // 线条颜色
          color: 'rgba(77,192,36,1)',
        },
      },
      itemStyle: {
        // color: 'rgba(248,172,6,1)',
        color: 'rgba(77,192,36,1)',
      },
      tooltip: {
        show: true,
      },
      areaStyle: {
        //区域填充样式
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: 'rgba(77,192,36,.3)',
                // color: 'rgba(248,172,6,.3)',
              },
              {
                offset: 1,
                color: 'rgba(77,192,36, 0)',
                // color: 'rgba(248,172,6, 0)',
              },
            ],
            false
          ),
          shadowColor: 'rgba(10,219,250, 0.5)', //阴影颜色
          shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
        },
      },
      data: L3,
    },
  ],

};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
